import React, { FC } from 'react';
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
} from '@mui/material';

type ConfirmModalProps = {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  title: string;
  text: string;
};

export const ConfirmModal: FC<ConfirmModalProps> = ({ open, onClose, onSuccess, title, text }) => {
  const handleSuccess = () => {
    onSuccess();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          No
        </Button>
        <Button onClick={handleSuccess} color="primary" variant="contained" autoFocus>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};
